<template>
  <div style=" position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
z-index: 1020">
    <div class="messaging-modal">
      <div style="
  width: 100%;
    box-shadow: #343434;
    padding: 8px;
    transition: box-shadow 0.2s ease-in-out;
    cursor: pointer;
    z-index: 1021;
    height: calc(70vh);
"
      >
    <vue-advanced-chat
        ref="chatWindow"
        style="width: 100%; pointer-events: auto"
        :height="'calc(70vh)'"
        :current-user-id="myUser"
        :room-id="roomId"
        :single-room="'true'"
        :rooms="JSON.stringify(loadedRooms)"
        :loading-rooms="JSON.stringify(loadingRooms)"
        :rooms-loaded="JSON.stringify(roomsLoaded)"
        :messages="JSON.stringify(messages)"
        :messages-loaded="messagesLoaded"
        :menu-actions="JSON.stringify(menuActionForRoom)"
        :message-selection-actions="JSON.stringify(messageSelectionActions)"
        :text-messages="JSON.stringify(textMessages)"
        :show-audio="'false'"
        :media-preview-enabled="'false'"
        :message-actions="JSON.stringify(messageActions)"
        :show-reaction-emojis="'false'"
        :show-emojis="'false'"
        :styles="JSON.stringify(styles)"
        :username-options="JSON.stringify({minUsers: 2, currentUser: false})"
        @fetch-messages="fetchMessages($event.detail[0])"
        @send-message="sendMessage($event.detail[0])"
        @menu-action-handler="handleRoomAction($event.detail[0])"
        @message-selection-action-handler="messageSelected($event.detail[0])"
        @message-action-handler="messageAction($event.detail[0])"
        @open-file="onOpenFile($event.detail[0])"
        :link-options="JSON.stringify({ disabled: false, target: '_self', rel: null })"
    >
      <div slot="spinner-icon-infinite-rooms">
        <div id="vac-circle" v-if="loadingRooms"></div>
      </div>
      <div slot="room-options" style="display: flex">
        <div
            v-if="menuActionForRoom.length"
            class="vac-svg-button vac-room-options"
            @click="menuOpened = !menuOpened"
        >
          <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              version="1.1"
              width="24"
              height="24"
              :viewBox="`0 0 24 24`"
          >
            <path id="menu" :d="'M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z'" />
          </svg>
        </div>
        <window-minimize class="icon-1_5x vac-svg-button vac-room-options" fillColor="#16aa13" :size="72" style="color: #000000" @click="handleRoomAction({name: 'closeChat'})"></window-minimize>
        <transition v-if="menuActionForRoom.length" name="vac-slide-left">
          <div
              v-if="menuOpened"
              v-click-outside="closeMenu"
              class="vac-menu-options"
          >
            <div class="vac-menu-list">
              <div v-for="action in menuActionForRoom" :key="action.name">
                <div
                    class="vac-menu-item"
                    @click="handleRoomAction(action)"
                >
                  {{ action.title }}
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </vue-advanced-chat>
    <media-preview v-if="showPreview" @close-media-preview="hidePreview" :file="previewFile"></media-preview>
    <b-modal size="lg" v-model="showModalMap" id="modal-map" centered
             body-class="my-body" hide-footer hide-header>
      <b-row style="margin-bottom: 0">
        <b-col style="height: 450px; padding: 0; margin-bottom: 0" id="map_container"
               ref="map_container">
        </b-col>
      </b-row>
    </b-modal>
      </div>
    </div>
    <div class="messaging-backdrop" @click.prevent="$emit('close-chat')"></div>
  </div>
</template>

<script>

import * as firestoreService from '@/shared/firebase/database'
import {register} from 'vue-advanced-chat'

import {isImageFile, Redirect_500, Redirect_Login, Server_URL} from "../../shared/utils";
import {
  arrayBufferToBase64,
  decryptAES,
  decryptChatMessages,
  decryptFile,
  decryptRooms,
  encryptAES,
  encryptEntry,
  encryptFile
} from "@/shared/crypto";
import {formatTimestamp, parseTimestamp} from "@/shared/dates";
import {v4, v4 as uuidv4} from 'uuid';
import MiniIcon from 'vue-material-design-icons/WindowClose.vue'
import MediaPreview from "../messaging/util/MediaPreview.vue"
import {updateLastRead} from "@/shared/firebase/database";
import WindowMinimize from 'vue-material-design-icons/Close.vue'

import clickOutside from '../../shared/click-outside'
import ZoomControl from 'mapbox-gl-controls/lib/zoom';
import LanguageControl from 'mapbox-gl-controls/lib/language';
import mapboxgl from 'mapbox-gl/dist/mapbox-gl';

register()
export default {
  name: "TaskMessaging",
  props: {
    room: Object,
    lastOnline: Date,
    isSecond: Boolean,
    isThird: Boolean,
  },
  components: {
    MiniIcon, MediaPreview, WindowMinimize
  },
  directives: {
    clickOutside: clickOutside
  },
  data() {
    return {
      menuOpened: false,
      customerNumber: "",
      // util
      loader: undefined,
      // file preview
      previewFile: null,
      showPreview: false,
      // chat config
      myUser: "",
      currentRoom: null,
      roomsPerPage: 20,
      rooms: [],
      roomId: '',
      roomsLoaded: false,
      loadingRooms: true,
      roomsLoadedCount: 0,
      selectedRoom: null,
      messagesPerPage: 20,
      messages: [],
      messagesLoaded: false,
      lastLoadedMessage: null,
      latestLoadedMessage: null,
      listeners: [],
      menuActions: [
        {name: "closeChat", title: "Minimieren"},
        {name: 'showUsers', title: 'Gruppenmitglieder anzeigen'},
        {name: 'inviteUser', title: 'Nutzer hinzufügen'},
        {name: 'leaveChat', title: 'Aus dem Chat austreten'},
      ],
      messageSelectionActions: [{name: 'newTask', title: 'Neue Aufgabe anlegen'}],
      messageActions: [
        {
          name: 'selectMessages',
          title: 'Markieren'
        },
        {
          name: 'newTaskFromMessage',
          title: 'Neue Aufgabe anlegen'
        },
        /*{
          name: 'showSeen',
          title: 'Info',
          onlyMe: true
        },*/
      ],
      styles: {
        message: {
          background: '#fff',
          backgroundMe: '#e8eff8',
        }
      },
      textMessages: {
        ROOMS_EMPTY: 'Sie haben noch keine Chats.',
        ROOM_EMPTY: 'Kein Chat geöffnet',
        NEW_MESSAGES: 'Neue Nachrichten',
        MESSAGE_DELETED: 'Nachricht geloescht',
        MESSAGES_EMPTY: 'Keine Nachrichten im Chat',
        SEARCH: 'Suchen',
        CANCEL_SELECT_MESSAGE: 'Selektion beenden',
        TYPE_MESSAGE: 'Nachricht schreiben',
        CONVERSATION_STARTED: 'Beginn der Konversation: ',
      },
      // timers
      refreshMessagesTimer: null,
      lastActive: null,
      participants: [],
      fetchedOnce: false,
      isBauhof: false,
      showModalMap: false,
    }
  },
  beforeMount() {
  },
  beforeDestroy() {
    this.listeners.forEach(listener => listener())
    this.listeners = []
    this.$refs.chatWindow.shadowRoot.removeEventListener("click", this.preventNav);
  },
  computed: {
    menuActionForRoom() {
      for (let i = 0; i < this.rooms.length; i++) {
        if (this.rooms[i].roomId === this.selectedRoom) {
          let r = this.rooms[i];
          let res = [];
          //res.push(this.menuActions[0]);
          res.push(this.menuActions[1]);
          if (r.room_type !== "chat") {
            res.push(this.menuActions[2]);
            for (let j = 0; j < r.users.length; j++) {
              if (r.users[j]._id === this.myUser) {
                res.push(this.menuActions[3]);
                break;
              }
            }
          }
          return res;
          break;
        }
      }
      return [];
    },
    loadedRooms() {
      return this.rooms.slice(0, this.roomsLoadedCount)
    },
  },
  mounted() {
    var sheet = new CSSStyleSheet();
    sheet.replaceSync( `.vac-message-wrapper .vac-message-container {
  width: 95% !important;
}


.vac-message-wrapper .vac-message-box{
  width: 100% !important;
  min-width: 100% !important;
}
.vac-message-files-container .vac-file-wrapper .vac-file-container {
    width: auto !important;
    max-width: 150px !important;
  }
  .vac-message-files-container .vac-file-wrapper {
     margin: 0 auto;
  }

  #vac-icon-double-checkmark-seen {
     fill: #6d6def !important;
  }
  .vac-message-actions-wrapper .vac-menu-left {
      right: 15px !important;
   }
   .vac-col-messages {
      border-radius: 8px;
      }

.vac-message-wrapper .vac-offset-current {
  margin-left: 0px !important;
}`)
    this.$refs.chatWindow.shadowRoot.adoptedStyleSheets = [ sheet ]
    this.$refs.chatWindow.shadowRoot.addEventListener("click", this.preventNav)
    this.currentUserId = this.$cookies.get("ps_user_id");
    this.customerNumber = this.$cookies.get("ps_customer_number");
    this.myUser = this.currentUserId;
    this.isBauhof = navigator.userAgent.startsWith("Windows - BisOffice");
    // process the room from prop
    const cp = JSON.parse(JSON.stringify(this.room))
    let data = [cp]
    decryptRooms(sessionStorage.getItem("aes"), data).then(res => {
      this.processRooms(res)
    })
    updateLastRead(this.customerNumber, this.room.roomId, this.currentUserId)
    if (this.lastOnline) {
      this.lastActive = new Date(this.lastOnline.getTime());
    }
  },

  methods: {
    showMapIfNeeded() {
      mapboxgl.accessToken = 'pk.eyJ1Ijoic3ZlbnBldGVyc2VuIiwiYSI6ImNqc3Z0YW82dDBhbDE0NXFpOGRzOXI4NWsifQ.Sq1nJiC3uKfA5yfYN8wR9w';
      this.map = new mapboxgl.Map({
        container: 'map_container',
        style: 'mapbox://styles/mapbox/outdoors-v11',
        center: [this.lon, this.lat],
        zoom: 18,
        minZoom: 5,
        maxPitch: 0,
        attributionControl: false
      });

      this.map.addControl(new ZoomControl(), 'bottom-right');
      const languageControl = new LanguageControl({
        language: 'de',
      });
      this.map.addControl(languageControl);

      this.map.addControl(new mapboxgl.AttributionControl(), "top-right");

      this.marker = null;
      this.geojson = {};
      this.map.on('load', this.mapLoad);
    },
    mapLoad() {
      setTimeout(() => {
        if (this.marker === null) {
          let el = document.createElement('div');
          el.className = 'marker';

          this.marker = new mapboxgl.Marker({
            element: el,
            anchor: 'center',
          })
              .setLngLat([this.lon, this.lat])
              .addTo(this.map);
        }
        this.map.resize();
      });
    },
    showMap(lat, lon) {
      this.showModalMap = true;
      this.lat = lat;
      this.lon = lon;
      this.$nextTick(() => {
        this.showMapIfNeeded();
      });
    },
    preventNav(event) {
      const { target } = event
      // handle only links that do not reference external resources
      if (target && target.href && target.href.includes("coordinates?lat=")) {

        event.preventDefault();
        let coords = target.href.split("coordinates?lat=")[1]
        coords = coords.split("&lon=")
        this.showMap(parseFloat(coords[0]), parseFloat(coords[1]))
      }
    },
    closeMenu() {
      this.menuOpened = false
    },
    getFistCharacter(name) {
      return name.charAt(0).toUpperCase()
    },
    messageSelected({ roomId, action, messages }) {
      let messageIds = [];
      for (let i = 0; i < messages.length; i++) {
        messageIds.push(messages[i]._id);
      }
      this.createTaskFromMessages(roomId, messageIds);
    },
    messageAction({ roomId, action, message }) {
      if (action.name === 'newTaskFromMessage') {
        this.createTaskFromMessages(roomId, [message._id])
      } else {

      }
    },
    createTaskFromMessages(roomId, messageIds) {
      let dataId = uuidv4();
      sessionStorage.setItem(dataId, JSON.stringify({
        roomId: roomId,
        messages: messageIds
      }));
      this.$router.push("/create?message_payload=" + dataId);
    },
    hidePreview() {
      this.showPreview = false;
      URL.revokeObjectURL(this.previewFile.url);
    },
    async onOpenFile({ message, file }) {
      if (navigator.userAgent === "BisOfficeMobile") {
        Android.onLoadFile(file.file.server_url);
        return
      }
      this.showLoader();
      // get the file blob
      try {
        let response = await this.$http.get(
            file.file.server_url, {responseType: 'blob'}
        )
        let blobData = await response.blob();
        let dec = await decryptFile(sessionStorage.getItem("aes"), await blobData.arrayBuffer());
        this.hideLoader();
        if (this.isBauhof && file.action !== "preview") {
          try {
            windowsFileService.onFile(
                arrayBufferToBase64(dec),
              file.file.name,
              blobData.type
            ).then(r => {
              if (r && !r.Success) {
                console.log(r)
              }
            }).catch(e => {
              console.log(e)
            });
          } catch (e) {
            console.log(e);
          }
          return
        }
        const b =  new File([dec], file.file.name, {type: blobData.type});
        const blobUrl = URL.createObjectURL(b);
        if (file.action === "preview") {
          this.previewFile = {url: blobUrl}
          this.showPreview = true;
        } else {
          window.open(blobUrl, file.file.name);
          setTimeout(() => {
            URL.revokeObjectURL(blobUrl);
          }, 1000);
        }

      } catch (error) {
        console.log(error)
        //this.responseError(error)
      }
    },

    async handleRoomAction(action) {
      this.closeMenu();
      if (action.name === "closeChat") {
        this.$emit("close-chat");
        return
      } else if (action.name === "showUsers") {
        this.$emit("show-group");
        return
      }  else if(action.name === "inviteUser") {
        this.$emit('show-invite')
        return
      } else if(action.name === "leaveChat") {
        await this.leaveChat(this.roomId)
        return
      }
    },
    isInRoom(room, userId) {
      let found = false;
      for (let j = 0; j < room.users.length; j++) {
        if (userId === room.users[j]._id || userId === this.myUser) {
          found = true;
          break
        }
      }
      return found;
    },
    async removeMessageInbox(maxAge) {
      let topicId = this.rooms[0].roomId;
      let messageType = 4;
      if (this.rooms[0].room_type === "task_int") {
        topicId = topicId.substring(0, topicId.length-9)
        messageType = 5;
      }
      let req = {
        topic_id: topicId,
        message_type: messageType,
        max_age: maxAge,
      }
      try {
        await this.$http.post(
            Server_URL + '/auftragsbuch/inbox/delete_by_age', req
        )
      } catch (e) {
        console.log(e);
      }
    },
    async sendMessage({content, roomId, files, replyMessage}) {
      let encryptedContent = await encryptAES(sessionStorage.getItem("aes"), content);
      // first insert the message
      let res = JSON.parse(sessionStorage.getItem(this.$cookies.get("ps_user_id")));
      let req = {
        room_id: roomId,
        content: encryptedContent,
        content_plain: content,
        user_name: res.full_name,
      }
      if (files === null) {
        let response;
        try {
          response = await this.$http.post(
              Server_URL + '/auftragsbuch/messaging/message', req
          )
        } catch (e) {
          this.responseError(e)
          return
        }
        if (response.status !== 200) {
          window.location = Redirect_500;
          return
        }
        let addedUser = response.body.added_user;
        if (addedUser && addedUser._id !== "") {
          this.rooms[0].users.push({
            username: "",
            _id: addedUser._id
          });
          this.rooms = [...this.rooms]
          this.$emit('user-added', this.rooms[0].roomId, addedUser._id);
        }

        if (!this.currentRoom.is_active) {
          this.currentRoom.is_active = true;
          this.messagesLoaded = false;
          this.fetchMoreMessages(this.rooms[0])
          this.$emit('chat-active', this.rooms[0].roomId);
        }
      } else {
        for (let i = 0; i < files.length; i++) {
          files[i].uuid = uuidv4();
          let f = files[i];
          let tempMessage = {
            _id: '',
            indexId: f.uuid,
            content: i === files.length - 1 ? req.content_plain : '',
            senderId: this.currentUserId,
            username: res.full_name,
            timestamp: parseTimestamp(new Date(), 'HH:mm'),
            date: parseTimestamp(new Date(), 'DD MMMM YYYY'),
            saved: true,
            files: [
              {
                name: f.name + (f.extension === "" ? "" : "." + f.extension),
                size: f.size,
                type: f.type,
                audio: false,
                duration: 0.0,
                url: f.localUrl,
                progress: 0,
                uuid: f.uuid,
              }
            ]
          }
          this.messages.push(tempMessage);
        }
        for (let i = 0; i < files.length; i++) {
          let data = new FormData();
          let f = files[i];
          data.set("room_id", roomId);
          data.set("message_id", f.uuid)
          data.set("file_id", f.uuid)
          data.set("user_name", req.user_name)
          if (i === files.length - 1 && req.content_plain !== '') {
            // last message set content
            data.set("content", req.content);
            data.set("contentPlain", req.content_plain);
          } else {
            data.set("contentAutomatic", "true")
            data.set("contentPlain", "Neue Datei: " + f.name + (f.extension === "" ? "" : "." + f.extension))
            let encryptedContent = await encryptAES(sessionStorage.getItem("aes"), "Neue Datei: " + f.name + (f.extension === "" ? "" : "." + f.extension));
            data.set("contentPlain", encryptedContent);
          }
          try {
            if (!isImageFile({type: f.type})) {
              let enc = await encryptFile(sessionStorage.getItem("aes"), await f.blob.arrayBuffer())
              data.set("upload_file", new Blob([enc], {type: f.type}), f.name + (f.extension === "" ? "" : "." + f.extension))
            } else {
              data.set("upload_file", f.blob, f.name + (f.extension === "" ? "" : "." + f.extension))
              data.set("enc_key", sessionStorage.getItem("aes"))
            }
            try {
              let response = await this.$http.post(
                  Server_URL + '/auftragsbuch/messaging/message_file', data, {
                    headers: {
                      'Content-Type': 'multipart/form-data'
                    },
                    progress: (e) => {
                      if (e.lengthComputable) {
                        let progress = (e.loaded / e.total * 100);
                        for (let j = 0; j < this.messages.length; j++) {
                          if (this.messages[j].indexId === f.uuid) {
                            this.messages[j].files[0].progress = Math.round(progress);
                            this.messages = [...this.messages]
                            break;
                          }
                        }
                      }
                    }
                  }
              )
              if (response.status !== 200) {
                window.location = Redirect_500;
                return
              }
              //let newMessages = response.body.messages;
              let addedUser = response.body.added_user;
              if (addedUser && addedUser._id !== "") {
                this.$emit('user-added', this.rooms[0].roomId, addedUser._id);
              }

              if (!this.currentRoom.is_active) {
                this.currentRoom.is_active = true;
                this.messagesLoaded = false;
                this.fetchMoreMessages(this.rooms[0])
              }
            } catch (r) {
              this.responseError(r)
            }
          }catch (e) {
            console.log(e)
          }
        }
      }
      this.lastActive = new Date();
    },
    getThumbnailUrl(url, id, fileType) {
      if (!isImageFile({type: fileType})) {
        return ""
      } else {
        let splits = url.split("/")
        splits[splits.length - 1] = id + "_thumb.jpg"
        let res = splits.join("/");
        return res
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_Login;
      }
    },
    showLoader() {
      this.hideLoader();
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    processRooms(data) {
      this.roomsLoaded = data.length === 0 || data.length < this.roomsPerPage
      let roomId = 0;
      const roomsToAdd = [];
      for (let i = 0; i < data.length; i++) {
        const room = data[i];
        const roomContacts = room.users.filter(
            user => user._id !== this.currentUserId
        )
        if (room.room_type === "chat") {
          room.roomName =
              roomContacts.map(user => user.username).join(', ')
          room.avatar = "/ic_chat.png"
        } else if (room.room_type === "group") {
          room.avatar = "/ic_group.png"
        } else if (room.room_type === "task") {
          room.avatar = "/ic_task.png"
        } else if (room.room_type === "task_int") {
          room.avatar = "/ic_task_int.png"
        } else {
          room.avatar = "/ic_admin.png"
        }
        this.rooms[0] = room;
        this.rooms = [...this.rooms]
        roomId = room.roomId;
      }

      if (!this.rooms.length) {
        this.roomsLoadedCount = 0
      } else {
        this.roomsLoadedCount = this.rooms.length
      }
      this.loadingRooms = false
      if (roomId !== 0) {
        this.$nextTick(() => {
          //this.roomId = roomId;
        });
      }
    },
    fetchMessages({room, options = {}}) {
      this.selectedRoom = room.roomId;
      this.currentRoom = room;
      if (this.currentRoom.is_active) {
        this.fetchMoreMessages(room);
      } else {
        this.messagesLoaded = true
      }
    },
    fetchMoreMessages(room) {
      if (!this.fetchedOnce) {
        const listener = firestoreService.listenParticipants(this.customerNumber, room.roomId, data => {
          if (this.selectedRoom !== room.roomId) return;
          this.participants = data;
          if (!this.fetchedOnce) {
            this.fetchedOnce = true;
            this.fetchMoreMessages(room)
          } else {
            this.calculateSeen();
          }
          //check if we have new users
          for (let i = 0; i < this.participants.length; i++) {
            let p = this.participants[i].id;
            let found = false;
            for (let j = 0; j < this.rooms[0].users.length; j++) {
                if (p === this.rooms[0].users[j]._id) {
                  found = true;
                  break;
                }
            }
            if (!found) {
              this.rooms[0].users.push({
                username: '',
                _id: p,
              })
              this.rooms = [...this.rooms];
              this.$emit('user-added',this.rooms[0].roomId, p);
            }
          }

        })
        this.listeners.push(listener);
      } else {
        this.selectedRoom = room.roomId
        firestoreService
            .getMessages(this.customerNumber, room.roomId, this.messagesPerPage, this.lastLoadedMessage)
            .then(({data, docs}) => {
              if (this.selectedRoom !== room.roomId) return;
              decryptChatMessages(sessionStorage.getItem("aes"), data).then(res => {
                if (this.selectedRoom !== room.roomId) return;
                if (data.length === 0 || data.length < this.messagesPerPage) {
                  setTimeout(() => {
                    this.messagesLoaded = true
                  }, 0)
                }
                this.processMessages(res, "old")
                if (!this.lastLoadedMessage) {
                  this.latestLoadedMessage = docs[0];
                  this.removeMessageInbox(res[0].create_date.toDate())
                  this.listenMessages(room);
                }
                this.lastLoadedMessage = docs[docs.length - 1]
              })
            })
      }
    },
    listenMessages(room) {
      const listener = firestoreService.listenMessages(
          this.customerNumber,
          room.roomId,
          this.latestLoadedMessage,
          data => {
            if (this.selectedRoom !== room.roomId || !data || data.length === 0) return;
            this.removeMessageInbox(data[0].create_date.toDate())
            decryptChatMessages(sessionStorage.getItem("aes"), data.reverse()).then(res => {
              if (this.selectedRoom !== room.roomId) return;
              this.processMessages(res,  "new")
            })
          }
      )
      this.listeners.push(listener)
    },



    getMessageIndex(id, indexId) {
      for (let i = 0; i < this.messages.length; i++) {
        if (this.messages[i]._id === id) {
          return i;
        } else if (indexId !== undefined && indexId !== '' && this.messages[i].indexId === indexId) {
          return i;
        }
      }
      return -1;
    },
    processMessages(data, direction) {
      if (direction !== "new") {
        this.messagesLoaded = data.length === 0 || data.length < this.messagesPerPage;
      }
      let hasNew = false;
      for (let i = 0; i < data.length; i++) {
        const message = this.formatMessage(data[i]);
        if (!message.system && message.senderId !== this.myUser && direction === 'new') {
          hasNew = true;
        }
        // check if the message already exists, if so update
        let index = this.getMessageIndex(message._id, message.indexId);
        if (index !== -1) {
          this.messages[index] = data[i];
        } else if (direction === 'new') {
          this.messages.push(data[i])
        } else {
          this.messages.unshift(data[i])
        }
      }
      this.messages = [...this.messages]
      if (hasNew) {
        var audioFile = new Audio('/notification.mp3');
        audioFile.play()
        updateLastRead(this.customerNumber, this.room.roomId, this.currentUserId)
      }
    },
    calculateSeen() {
      for (let i = 0; i < this.messages.length; i++) {
        let m = this.messages[i];
        if (m.from_id === this.myUser && !m.seen) {
          this.messages[i].seen = this.isMessageSeen(m)
        }
      }
      this.messages = [...this.messages];
    },
    isMessageSeen(m) {
      if (m.seen) {
        return true;
      }
      let seen = true;
      for (let i = 0; i < this.participants.length; i++) {
        let p = this.participants[i];
        if (p.id !== "admin" && p.id !== this.myUser && m.create_date.toDate().getTime() > p.last_active.toDate().getTime()) {
          seen = false;
          break;
        }
      }
      return seen;
    },
    formatMessage(message) {
      message._id = message.id;
      message.senderId = message.from_id;
      if (message.from_id !== this.myUser && this.lastActive && this.lastActive.getTime() < message.create_date.toDate().getTime()) {
        message.seen = false;
      } else if (message.from_id !== this.myUser) {
        message.seen = true;
      } else {
        message.seen = this.isMessageSeen(message);
      }
      message.timestamp = parseTimestamp(message.create_date.toDate(), 'HH:mm');
      message.date = parseTimestamp(message.create_date.toDate(), 'DD MMMM YYYY');
      message.distributed = true;
      if (message.value_3 === "system") {
        message.system = true;
      }
      if (message.value_1 !== "") {
        message.indexId = message.value_1;
      }
      if (message.message_type === 'file') {
        message.files = [
          {
            name: message.file_name,
            size: message.file_size,
            type: message.content_type,
            server_url: Server_URL + "/auftragsbuch/" + message.url,
            url: this.getThumbnailUrl(Server_URL + "/auftragsbuch/" + message.url, message.id, message.content_type),
          }
        ]
      } else if (message.message_type === "coordinates") {
        let latRounded = Math.round(message.lat * 10000) / 10000
        let lonRounded = Math.round(message.lon * 10000) / 10000
        message.content = "[Standort: "+latRounded + " " + lonRounded + "](coordinates?lat="+message.lat + "&lon=" + message.lon +")"
      }

      // set username
      let res = JSON.parse(sessionStorage.getItem(message.from_id));
      if (res !== null) {
        message.username = res.first_name + " " + res.surname;
        return message;
      } else {
        message.username = message.from_name;
      }
    },
    async leaveChat(roomId) {
      let isInChat = false;
      for (let i = 0; i < this.rooms[0].users.length; i++) {
        if (this.rooms[0].users[i]._id === this.myUser) {
          isInChat = true;
          break
        }
      }
      if (!isInChat) {
        this.$bvToast.toast('Sie sind aktuell kein Teilnehmer dieses Chats.', {
          title: 'Verlassen nicht möglich',
          variant: 'warning',
          solid: true,
          toaster: 'b-toaster-bottom-right'
        })
        return
      }
      this.showLoader();
      let me = JSON.parse(sessionStorage.getItem(this.$cookies.get("ps_user_id")));
      let messagePlain = me.full_name + " hat den Chat verlassen."
      let encryptedContent = await encryptAES(sessionStorage.getItem("aes"), messagePlain);
      let req = {
        room_id: roomId,
        message: encryptedContent,
      }
      this.$http.post(
          Server_URL + '/auftragsbuch/messaging/leave_room', req
      ).then(this.onLeaveOk, this.responseError)
    },
    onLeaveOk(response) {
      this.hideLoader();
      if (response.status === 200) {
        for (let i = 0; i < this.rooms[0].users.length; i++) {
          if (this.rooms[0].users[i]._id === this.myUser) {
            this.rooms[0].users.splice(i, 1);
            this.rooms = [... this.rooms]
            break
          }
        }
        this.$emit('leave-room');
      } else {
        window.location = Redirect_500;
      }
    },
  }
}
</script>

<style>
form-control:disabled, .form-control[disabled] {
  color: black !important;
}

.text-black {
  color: black;
}

.tree-default .tree-disabled > .tree-checkbox {
  display: none;
}

.tree-default .tree-disabled {
  color: inherit !important;
}

</style>

<style scoped>

.messaging-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1020;
  width: 100vw;
  height: 100vh;
  background-color: #000;
  opacity: .5;
}

.messaging-modal {
  flex-direction: column;
  justify-content: center;
  height: 100%;
  width: 40vw;
  min-width: 350px;
  margin: 1.75rem auto;
  display: flex;
  align-items: center;
}

#vac-circle {
  height: 20px;
  width: 20px;
}

#vac-circle {
  margin: auto;
  height: 28px;
  width: 28px;
  border: 3px rgba(0, 0, 0, .25) solid;
  border-top: 3px #333 solid;
  border-right: 3px #333 solid;
  border-bottom: 3px #333 solid;
  border-radius: 50%;
  -webkit-animation: vac-spin 1s infinite linear;
  animation: vac-spin 1s infinite linear;
}

@keyframes vac-spin {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0);
  }

  to {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}

.my-tree {
  max-height: calc(30vh - 70px);
  overflow: auto;
}

.chat-avatar {
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 50%;
  font-size: 18px;
  color: rgb(255, 255, 255);
  text-align: center;
  background: rgb(0, 0, 0);
  margin-top: 5px;
  margin-left: 4px;
}

.chat-avatar.mine {
  background: rgb(203, 33, 33);
}

</style>

<style>

.second {
  right: max(20vw, 364px) !important;
}

.third {
  right: max(39vw, 700px) !important;
}

.marker {
  background-image: url('../../../public/mangel_marker.png');
  background-size: cover;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
}

.vac-svg-button>.material-design-icon__svg {
  bottom: 0 !important;
}

.vac-room-header .vac-room-options {
  margin-left: auto;
}

.vac-menu-options {
  position: absolute;
  right: 10px;
  top: 20px;
  z-index: 9999;
  min-width: 150px;
  display: inline-block;
  border-radius: 4px;
  font-size: 14px;
  color: var(--chat-color);
  overflow-y: auto;
  overflow-x: hidden;
  contain: content;
  box-shadow: 0 2px 2px -4px #0000001a, 0 2px 2px 1px #0000001f, 0 1px 8px 1px #0000001f;
}

.vac-menu-item {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 100%;
  flex: 1 1 100%;
  min-height: 30px;
  padding: 5px 16px;
  position: relative;
  white-space: nowrap;
  line-height: 30px;
}

.vac-menu-list :hover {
  background-color: #e4e5e6;;
  transition: background-color .3s cubic-bezier(.25,.8,.5,1);
}

.vac-menu-list {
  border-radius: 4px;
  display: block;
  cursor: pointer;
  background: var(--chat-dropdown-bg-color);
  padding: 6px 0;
}

 .vac-svg-button:hover {
   transform: scale(1.1);
   opacity: .7;
 }
 .vac-card-window * {
   font-family: inherit;
 }
 .vac-svg-button {
   max-height: 30px;
   display: flex;
   cursor: pointer;
   transition: all .2s;
 }

.vac-message-wrapper .vac-message-container {
  width: 90% !important;
}


.vac-message-wrapper .vac-message-box{
  width: 90% !important;
  min-width: 90% !important;
}

.vac-message-wrapper .vac-message-container {
  margin-left: 10% !important;
}
</style>
